
import Vue from "vue";
import { checkHasModule } from "@/router";
import { MODULE } from "@/config/modules";

export default Vue.extend({
	created(){
		if (!checkHasModule(MODULE.CRM, this.$router)){
			throw new Error("MISSING MODULE");
		}
	}
});

